<template>
  <ErrorMessage :name="name" v-slot="{ message }">
    <div class="grp-error">
      <img v-if="hasIcon" src="@/assets/img/icon-error.svg" alt="" class="grp-error--icon" />
      <p class="grp-error--message">{{ message }}</p>
    </div>
  </ErrorMessage>
</template>

<script>
import { ErrorMessage } from 'vee-validate';

export default {
  name: 'BaseErrorMessage',
  components: { ErrorMessage },
  props: {
    name: { type: String, required: true },
    hasIcon: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.grp-error {
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  margin-top: 8px;

  &--icon {
    width: 16px;
    height: 16px;
  }

  &--message {
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: $error;
  }
}
</style>
